import script from "./testTime.vue?vue&type=script&setup=true&lang=js"
export * from "./testTime.vue?vue&type=script&setup=true&lang=js"

import "./testTime.vue?vue&type=style&index=0&id=7069e8ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7069e8ba"]])

export default __exports__